import React, { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const PricingContext = React.createContext(null);

const { Provider } = PricingContext;
export const PricingProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}